// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AdminSettings_wrapper__1Llwx","wrapper__tab":"AdminSettings_wrapper__tab__2GQWh"};